import { useEffect, useState } from "react";
import { Col, Offcanvas, Row } from "react-bootstrap";
import DatosFactura from "../Components/Factura/DatosFactura";
import ProcedimientosPendienteFactura from "../Components/Factura/ProcedimientosPendienteFactura";
import TotalFactura from "../Components/Factura/TotalesFactura";
import ListaFormaPagos from "../Components/Factura/ListaFormaPagos";
import ProcedimientosNuevosFactura from "../Components/Factura/ProcedimientosNuevosFactura";
import ConfirmBilling from "../Components/Factura/ConfirmBilling";
import { useDispatch, useSelector } from "react-redux";
import { resetFormaPagos, resetProcedimientoFactura } from "../redux/actions";
import OffcanvasCliente from "../Components/Cliente/OffcanvasCliente";
import ModalCheque from "../Components/Factura/Pagos/ModalCheque";
import ModalTarjetas from "../Components/Factura/Pagos/ModalTarjetas";
import ModalTransferencia from "../Components/Factura/Pagos/ModalTransferencia";
import ModalPromociones from "../Components/Factura/Promociones/ModalPromociones";
import ModalPlanes from "../Components/Factura/Planes/ModalPlanes";
import { usePacienteSeguro } from "../hook/usePacienteSeguro";
import BarraFactura from "../Components/Factura/Crear/BarraFactura";
import CabeceraProcedimientos from "../Components/Factura/Crear/CabeceraProcedimientos";
import TablaProcedimientos from "../Components/Factura/Crear/TablaProcedimientos";
import AntesDeEmitir from "../Components/Factura/Crear/AntesDeEmitir";
import Resumen from "../Components/Factura/Crear/Resumen";
import TarjetaCliente from "../Components/Factura/Crear/TarjetaCliente";
import PanelAgregar from "../Components/Factura/Crear/PanelAgregar";
import ModalAplicarPlan from "../Components/Factura/Crear/ModalAplicarPlan";
import { ListCategoriaExamen } from "../Service/Service.categoriaExamen";
import { tituloClinico } from "../utils/textoClinico";
import { precargar, leer, claveDe } from "../utils/cachePanelAgregar";

/* FASE 1: el boton "Pendientes" abre el PANEL nuevo en vez del modal viejo.
   El modal viejo NO se borra -- sigue montado y funcionando -- para poder
   volver a el con una sola linea mientras verificamos que el panel lo
   reemplaza bien. Poner esto en `false` restaura el comportamiento anterior
   por completo. */
const USAR_PANEL_AGREGAR = true;

/* FASE 3: "Aplicar plan" pasa al modal nuevo, con vista previa. El viejo
   (ModalPlanes) sigue montado y en el codigo; poner esto en `false` vuelve a
   el con una linea. */
const USAR_PLAN_CON_PREVIA = true;

function FacturaCrear() {

    const dispatch = useDispatch();

    const [pacienteSeleccionado, setPacienteSeleccionado] = useState(null);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [seguroSeleccionado, setSeguroSeleccionado] = useState(null);
    const [showProcedimientoPendientes, setShowProcedimientoPendientes] = useState(false);
    const [showPanelAgregar, setShowPanelAgregar] = useState(false);
    const [pestanaPanel, setPestanaPanel] = useState("pendientes");
    // Cuando se llega desde la barra de lote, el plan se aplica SOLO a lo
    // seleccionado. `null` = a toda la factura.
    const [lineasParaPlan, setLineasParaPlan] = useState(null);
    const [showPlanPrevia, setShowPlanPrevia] = useState(false);
    /* Cuantos pendientes tiene el paciente, para el contador del boton.
       Se LEE DE LA CACHE de la precarga -- nunca dispara una peticion: si la
       precarga aun no ha llegado, se queda en `null` y no se pinta contador. */
    const [conteoPendientes, setConteoPendientes] = useState(null);
    // Catalogo de 7 filas. Se pide UNA vez aqui para que el panel pueda
    // ofrecer el filtro por categoria sin pedirlo el mismo cada vez que se
    // abre -- el modal viejo lo pedia en cada apertura.
    const [categoriasExamen, setCategoriasExamen] = useState([]);
    const [showProcedimientoNuevos, setShowProcedimientoNuevos] = useState(false);
    const [showPromociones, setShowPromociones] = useState(false);
    const [showPlanes, setShowPlanes] = useState(false);
    const [showConfirmBilling, setShowConfirmBilling] = useState(false);
    const [showCliente, setShowCliente] = useState(false);
    const [reloadClientes, setReloadClientes] = useState(false);
    const [infoAdicional, setInfoAdicional] = useState("");
    // FACTURA-UI FASE 3: filtra lo que YA está en la factura. No carga el
    // catálogo -- una petición nueva es justo lo que este rediseño no hace.
    const [filtroProcedimientos, setFiltroProcedimientos] = useState("");

    const [datosBanco, setDatosBanco] = useState(null);
    const [showDatosCheque, setShowDatosCheque] = useState(false);
    const [showDatosTarjeta, setShowDatosTarjeta] = useState(false);
    const [showDatosTransferencia, setShowDatosTransferencia] = useState(false);

    const [pacienteSelectedDetails, setpacienteSelectedDetails] = useState(null);

    const procedimientos = useSelector((state) => state.facturaredux.procedimientos);

    const datoPaciente  = usePacienteSeguro();


    // Los tres botones siguen existiendo (criterio 3: ninguna accion
    // desaparece); ahora los tres abren el MISMO panel, cada uno en su
    // pestana, en vez de tres modales con tres disenos distintos.
    const abrirPanel = (pestana) => {
        setPestanaPanel(pestana);
        setShowPanelAgregar(true);
    };

    const handleCloseProcedimientoPendientes = () => {
        if (USAR_PANEL_AGREGAR) {
            abrirPanel("pendientes");
            return;
        }
        setShowProcedimientoPendientes(!showProcedimientoPendientes);
    }

    const handleProcedimientoNuevos = () => {
        if (USAR_PANEL_AGREGAR) {
            abrirPanel("catalogo");
            return;
        }
        setShowProcedimientoNuevos(!showProcedimientoNuevos);
    }

    const handlePromociones = () => {
        if (USAR_PANEL_AGREGAR) {
            abrirPanel("promociones");
            return;
        }
        setShowPromociones(!showPromociones);
    }
      
    const handlePlanes = () => {
        if (USAR_PLAN_CON_PREVIA) {
            setLineasParaPlan(null);
            setShowPlanPrevia(true);
            return;
        }
        setShowPlanes(!showPlanes);
    }

    // Desde la barra de lote: "Aplicar plan a estos".
    const handlePlanesALote = (lineas) => {
        setLineasParaPlan(lineas);
        setShowPlanPrevia(true);
    }

    const handleDatosCheque = () => {
        setShowDatosCheque(!showDatosCheque);
    }

    const handleDatosTarjeta = () => {
        setShowDatosTarjeta(!showDatosTarjeta);
    }

    const handleDatosTransferencia = () => {
        setShowDatosTransferencia(!showDatosTransferencia);
    }

    const handleAgregarDatoBancariosCheque = (datos) => {
        setShowDatosCheque(!showDatosCheque);
        setDatosBanco(datos);
    }

    const handleAgregarDatoBancariosTarjeta = (datos) => {
        setShowDatosTarjeta(!showDatosTarjeta);
        setDatosBanco(datos);
    }

    const handleAgregarDatoBancariosTransferencia = (datos) => {
        setShowDatosTransferencia(!showDatosTransferencia);
        setDatosBanco(datos);
    }

    const handleConfirmBilling = () => {
        setShowConfirmBilling(!showConfirmBilling);
    }

    const handleCancelBilling = () => {
        dispatch(resetFormaPagos());
        dispatch(resetProcedimientoFactura());
    }

    const handleClienteNew = () => {
        setShowCliente(!showCliente);
        if (showCliente) {
            setReloadClientes(prev => !prev);
        }
    }

    useEffect(() => {
        let vivo = true;
        ListCategoriaExamen().then((res) => {
            if (!vivo || !res?.data) return;
            setCategoriasExamen(
                res.data.map((c) => ({ value: c.IdCategoriaExamen, label: tituloClinico(c.Descripcion) }))
            );
        });
        return () => { vivo = false; };
    }, []);

    useEffect(() => {
        setPacienteSeleccionado(null);
        setSeguroSeleccionado(null);
        if (datoPaciente.paciente) {
            setPacienteSeleccionado(datoPaciente.paciente);
        } else if (datoPaciente.seguro) {
            setSeguroSeleccionado(datoPaciente.seguro);
        }
    }, [datoPaciente]);

    /* FASE 4 -- precarga.
       En cuanto hay paciente ya se sabe que se va a necesitar: sus pendientes
       y el tarifario de su cobertura. Se piden AQUI, en segundo plano, para
       que al pulsar "Agregar procedimientos" los datos ya esten.

       TRAMPA 4: no bloquea NADA. No se espera el resultado, no hay estado que
       dependa de el y los errores se descartan (ver cachePanelAgregar). Si la
       precarga falla o tarda, el panel se abre igual y pide lo que le falte
       mostrando su propio esqueleto. */
    useEffect(() => {
        if (!pacienteSeleccionado && !seguroSeleccionado) return;
        const clave = claveDe(
            pacienteSeleccionado?.value,
            seguroSeleccionado?.value
        );
        setConteoPendientes(null);
        precargar({
            // Los dos "seguros" NO son el mismo (ver cachePanelAgregar): el
            // primero es la aseguradora titular de la factura, el segundo la
            // cobertura del paciente. Se pasan tal cual, sin mezclarlos.
            pacienteId: pacienteSeleccionado?.value,
            seguroId: seguroSeleccionado?.value,
            seguroPacienteId:
                pacienteSeleccionado?.seguros?.idseguro ?? pacienteSeleccionado?.seguro_id,
        });

        /* La precarga es asincrona y no avisa. Se mira la casilla unas pocas
           veces y se para: es solo para pintar un contador, asi que no merece
           ni un observador ni un intervalo indefinido. */
        let intentos = 0;
        const reloj = setInterval(() => {
            const cacheado = leer(clave, "pendientes");
            if (Array.isArray(cacheado)) {
                setConteoPendientes(cacheado.length);
                clearInterval(reloj);
                return;
            }
            if (++intentos > 20) clearInterval(reloj);
        }, 400);
        return () => clearInterval(reloj);
    }, [pacienteSeleccionado, seguroSeleccionado]);
    
    return (
        <div className="page-content">
            <div className="container-fluid">
                {/* FACTURA-UI FASE 1: barra superior. El total y "Emitir
                    factura" viven aquí ADEMÁS de en el resumen del pie --
                    ambos botones comparten condición y abren el mismo modal.
                    Sustituye a la miga de pan que llevaba los cuatro botones,
                    ahora en la cabecera de procedimientos (FASE 3). */}
                <BarraFactura onEmitir={handleConfirmBilling} />


                {/* BLOQUE 1 -- Cliente, a todo el ancho */}
                <TarjetaCliente
                    onClienteSeleccionado={setClienteSeleccionado}
                    handleClienteNew={handleClienteNew}
                    reloadClientes={reloadClientes}
                />

                {/* BLOQUE 2 -- Procedimientos, a todo el ancho */}
                    <div className="fcrear__card">
                        <CabeceraProcedimientos
                            unificado={USAR_PANEL_AGREGAR}
                            conteoPendientes={conteoPendientes}
                            filtro={filtroProcedimientos}
                            onFiltro={setFiltroProcedimientos}
                            onPendientes={handleCloseProcedimientoPendientes}
                            onCatalogo={handleProcedimientoNuevos}
                            onPromociones={handlePromociones}
                            onPlanes={handlePlanes}
                            // Mismas condiciones que tenían los cuatro
                            // botones en la barra de título, copiadas tal cual.
                            puedePendientes={Boolean(pacienteSeleccionado || seguroSeleccionado)}
                            puedeCatalogo={Boolean(pacienteSeleccionado)}
                            puedePromociones={Boolean(pacienteSeleccionado)}
                            puedePlanes={Boolean(
                                pacienteSeleccionado &&
                                pacienteSeleccionado.tipo_seguros &&
                                pacienteSeleccionado.tipo_seguros.tipo === "SEGUROS" &&
                                procedimientos.length
                            )}
                        />
                        <TablaProcedimientos
                            filtro={filtroProcedimientos}
                            onAplicarPlanA={
                                USAR_PLAN_CON_PREVIA && pacienteSeleccionado ? handlePlanesALote : null
                            }
                            accionesVacio={
                                <div className="fcrear__vacio-acciones">
                                    <button
                                        type="button"
                                        className="fcrear__btn fcrear__btn--destacado"
                                        onClick={handleCloseProcedimientoPendientes}
                                        disabled={!pacienteSeleccionado && !seguroSeleccionado}
                                    >
                                        Ver pendientes
                                    </button>
                                    <button
                                        type="button"
                                        className="fcrear__btn"
                                        onClick={handleProcedimientoNuevos}
                                        disabled={!pacienteSeleccionado}
                                    >
                                        Agregar del catálogo
                                    </button>
                                </div>
                            }
                        />
                    </div>

                {/* BLOQUE 3 -- Pago | Antes de emitir | Resumen */}
                <div className="fcrear__pie">
                    <DatosFactura data={{
                        onPacienteSeleccionado: setPacienteSeleccionado,
                        onClienteSeleccionado: setClienteSeleccionado,
                        datosBanco: datosBanco,
                        handleDatosCheque: handleDatosCheque,
                        handleDatosTarjeta: handleDatosTarjeta,
                        handleDatosTransferencia: handleDatosTransferencia,
                        handleClienteNew: handleClienteNew,
                        reloadClientes: reloadClientes,
                        onInfoAdicional: setInfoAdicional,
                        onPacienteDetails: setpacienteSelectedDetails,
                        seccionVerificacion: <AntesDeEmitir hayPaciente={Boolean(pacienteSeleccionado || seguroSeleccionado)} />
                    }}
                    />
                    <Resumen
                        onEmitir={handleConfirmBilling}
                        onDescartar={handleCancelBilling}
                    />
                </div>

            </div>

            <ModalAplicarPlan
                abierto={showPlanPrevia}
                onCerrar={() => setShowPlanPrevia(false)}
                pacienteSeleccionado={pacienteSeleccionado}
                lineasObjetivo={lineasParaPlan}
            />

            <PanelAgregar
                abierto={showPanelAgregar}
                onCerrar={() => setShowPanelAgregar(false)}
                pestanaInicial={pestanaPanel}
                pacienteSeleccionado={pacienteSeleccionado}
                seguroSeleccionado={seguroSeleccionado}
                categorias={categoriasExamen}
            />

            <ModalPlanes 
                data={{
                    show: showPlanes,
                    handleClose: handlePlanes,
                    pacienteSeleccionado: pacienteSeleccionado,
                    pacienteSelectedDetails: pacienteSelectedDetails
                }}
            />

            <ModalPromociones
                data={{
                    show: showPromociones,
                    handleClose: handlePromociones,
                    pacienteSeleccionado: pacienteSeleccionado,
                    pacienteSelectedDetails: pacienteSelectedDetails
                }}
            />

            <ProcedimientosPendienteFactura
                data={{
                    show: showProcedimientoPendientes,
                    handleClose: handleCloseProcedimientoPendientes,
                    pacienteSeleccionado: pacienteSeleccionado,
                    seguroSeleccionado: seguroSeleccionado
                }}
            />

            <ProcedimientosNuevosFactura
                data={{
                    show: showProcedimientoNuevos,
                    handleClose: handleProcedimientoNuevos,
                    pacienteSeleccionado: pacienteSeleccionado,
                    pacienteSelectedDetails: pacienteSelectedDetails
                }}
            />

            <ModalCheque
                data={{
                    show: showDatosCheque,
                    handleClose: handleDatosCheque,
                    handleAgregarDatoBancarios: handleAgregarDatoBancariosCheque
                }}
            />

            <ModalTarjetas
                data={{
                    show: showDatosTarjeta,
                    handleClose: handleDatosTarjeta,
                    handleAgregarDatoBancarios: handleAgregarDatoBancariosTarjeta
                }}
            />

            <ModalTransferencia
                data={{
                    show: showDatosTransferencia,
                    handleClose: handleDatosTransferencia,
                    handleAgregarDatoBancarios: handleAgregarDatoBancariosTransferencia
                }}
            />

            <ConfirmBilling
                data={{
                    show: showConfirmBilling,
                    handleClose: handleConfirmBilling,
                    pacienteSeleccionado: pacienteSeleccionado,
                    clienteSeleccionado: clienteSeleccionado,
                    handleCancelBilling: handleCancelBilling,
                    infoAdicional: infoAdicional
                }}
            />

            <OffcanvasCliente
                data={{
                    showCliente: showCliente,
                    handleCloseCliente: handleClienteNew
                }}
            />
        </div>
    )
}

export default FacturaCrear;